import { render, staticRenderFns } from "./carApplyForm.vue?vue&type=template&id=0b88788b&scoped=true&"
import script from "./carApplyForm.vue?vue&type=script&lang=js&"
export * from "./carApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./carApplyForm.vue?vue&type=style&index=0&id=0b88788b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88788b",
  null
  
)

export default component.exports